export const availableForCommunication = [
    { option: "Yes", label: "Yes" },
    { option: "No", label: "No" },
]